(function() {
	function initSpoiler(selectorNavBlock, selectorNavBlock__header, cssClassBlockCollapsed) {
		const navBlocks = document.querySelectorAll(selectorNavBlock);
		for (let navBlock of navBlocks) {
			navBlock.querySelector(selectorNavBlock__header).addEventListener('click', function() {
				navBlock.classList.toggle(cssClassBlockCollapsed);
			});
		}
	}

	function initNavSpoilers() {
		initSpoiler(
			'.sys__nav-block',
			'.nav-block__header',
			'nav-block--collapsed'
		);
	}

	function initHelpBlockSpoilers() {
		initSpoiler(
			'.sys__help-block',
			'.help-block__header',
			'help-block--collapsed'
		);
	}

	document.addEventListener('DOMContentLoaded', function() {
		initNavSpoilers();
		initHelpBlockSpoilers();
	});
})();
